<template>
  <div class="p-6 flex flex-col">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NetworkContent from '@/helpers/networking/NetworkContent';
import { normalizeParticipantUsers } from '@/utils/userParticipants';

export default {
  name: 'UserProjectsLayout',
  provide() {
    return {
      participantUsers: () => this.participantUsers,
      userProjectContext: () => ({
        projectId: this.selectedProjectId,
        project: this.selectedProject,
      }),
    };
  },
  data() {
    return {
      participantUsers: [],
    };
  },
  computed: {
    ...mapGetters('pmProject', {
      selectedProjectId: 'selectedProjectId',
      selectedProject: 'selectedProject',
    }),
  },
  async mounted() {
    await Promise.all([
      this.loadParticipantUsers(),
      this.initializeUserProjectContext(),
    ]);
  },
  methods: {
    ...mapActions('pmProject', ['initializeUserProjectContext']),
    async loadParticipantUsers() {
      try {
        const { data } = await NetworkContent.getParticipants();
        this.participantUsers = normalizeParticipantUsers(data?.users ?? []);
      } catch {
        this.participantUsers = [];
      }
    },
  },
};
</script>
